export default __webpack_public_path__ + "static/media/emm.9fda287a.jpg";